/** @format */

export const DynamicDrawerSizes = {
	mobile: 'large',
	tablet: 'medium',
	desktop: 'small'
} as const;
